import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'stores';
import AdminUsersList from './components/AdminUsersList/AdminUsersList';

const AdminHome = () => {
  const { adminStore } = useStores();

  useEffect(() => {
    adminStore.fetchLocations();
  }, []);

  return (
    <main>
      <AdminUsersList />
    </main>
  );
};

export default observer(AdminHome);
